const buttons = document.querySelectorAll('.techpreneur-responsible-ai-how-we-embed-responsibility-buttons button');
const headings = document.querySelectorAll('[data-tab-copy]');
const image = document.querySelector('.responsible-ai-image');

const imageSources = [
  "https://cdn.shopify.com/s/files/1/0698/2887/0332/files/TP-Website-ResponsibleAIPage-AI-Principles-1.jpg?v=1747920715",
  "https://cdn.shopify.com/s/files/1/0698/2887/0332/files/TP-Website-ResponsibleAIPage-AI-Principles-2.jpg?v=1747920715",
  "https://cdn.shopify.com/s/files/1/0698/2887/0332/files/TP-Website-ResponsibleAIPage-AI-Principles-3.jpg?v=1747920715",
  "https://cdn.shopify.com/s/files/1/0698/2887/0332/files/TP-Website-ResponsibleAIPage-AI-Principles-4.jpg?v=1747920715",
  "https://cdn.shopify.com/s/files/1/0698/2887/0332/files/TP-Website-ResponsibleAIPage-AI-Principles-5.jpg?v=1747920716"
];

buttons.forEach((btn, i) => {
  btn.addEventListener('click', () => {
    buttons.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    headings.forEach(h => h.style.display = 'none');
    document.querySelector(`[data-tab-copy="${i}"]`).style.display = 'block';

    image.src = imageSources[i];
  });
});
